import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getChecklist, deleteChecklist } from '../../../api/list'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function Checklist(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='checklistList'
        columns={[{ id: 'dateCreate', name: 'дата создания', type: 'date', width:'20%' }, { id: 'name', name: 'Наименование' }]}
        createItem={can(SLUGS.CATALOG.CREATE)}
        deleteItem={can(SLUGS.CATALOG.DELETE)}
        loadAPI={{
          request: getChecklist,
        }}
        title='Контрольные листы'
        deleteAPI={deleteChecklist}
        {...props}
      />
    </div>
  )
};